import { Button } from "@components/ui/button";
import { Separator } from "@components/ui/separator";
import { SidebarTrigger } from "@components/ui/sidebar";
import { Trans } from "@lingui/react/macro";
import { DownloadIcon, SendIcon } from "lucide-react";
import { Feature } from "@components/Feature";
import { FEATURE } from "@/features";

export default function Header({
  onExport,
  onShare,
  heading,
}: {
  onExport: () => void;
  onShare: () => void;
  heading?: string;
}) {
  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6 max-w-7xl">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <p>{heading}</p>

        <Button
          type="button"
          className="ml-auto"
          variant="outline"
          onClick={onShare}
        >
          <SendIcon />
          <span className="sr-only">
            <Trans>Dela</Trans>
          </span>
        </Button>

        <Feature required={FEATURE.HAS_EXCEL_EXPORT_FEATURE}>
          <Button
            type="button"
            variant="outline"
            onClick={onExport}
            data-testid="open-export-modal"
          >
            <Trans>Exportera</Trans>
            <DownloadIcon />
          </Button>
        </Feature>
      </div>
    </header>
  );
}
